import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Feedback } from "./components/newsfeed/Feedback";
import { Search } from "./components/menunav_compo/Search";
import { Profile } from "./components/menunav_compo/Profile";
import { Notification } from "./components/menunav_compo/Notification";
import { AskQ } from "./components/askquestion/AskQ";
import NotFound from "./components/common/NotFound";
import { CompleteProfile } from "./components/auth/CompleteProfile";
import { Addnewidea } from "./components/fyp/Addnewidea";
import { Projects } from "./components/projects/Projects";
import { Postproject } from "./components/projects/Postproject";
import { Scholarship } from "./components/scholarships/Scholarship";
import { PostScholarships } from "./components/scholarships/PostScholarships";
import { Internship } from "./components/internships/Internship";
import { Postinternship } from "./components/internships/Postinternship";
import { Userinternship } from "./components/internships/Userinternship";
import { Hostels } from "./components/hostel/Hostels";
import { Posthostel } from "./components/hostel/Posthostel";
import { Fyps } from "./components/fyp/Fyps";
import { Addalready } from "./components/fyp/Addalready";
import { Seealready } from "./components/fyp/Seealready";
import { Listnew } from "./components/fyp/Listnew";
// import {useState} from 'react'
import LoadingBar from "react-top-loading-bar";
import { Settings } from "./components/menunav_compo/Settings";
import { Answers } from "./components/newsfeed/Answers";
import { Deletenewfyp } from "./components/fyp/Deletenewfyp";
import { Usernewsfeed } from "./components/newsfeed/usernewsfeed";
import { Deletealreadyfyp } from "./components/fyp/Deletealreadyfyp";
import { Userhostels } from "./components/hostel/userhostel";
import { Userprojects } from "./components/projects/userprojects";
import { Userscholarship } from "./components/scholarships/userscholarships";
import VerifyEmail from "./components/verifications/VerifyEmail";
import ForgotPassword from "./components/verifications/ForgotPassword";
import RecoverPassword from "./components/verifications/RecoverPassword";
import PrivateRoute from "./components/auth/PrivateRoute";
import { Box, createTheme, Stack, ThemeProvider, Avatar } from "@mui/material";
/********** */
import Navbar from "./components/Navbar/Navbar";
import NewsFeed from "./Pages/NewsFeed";
import LoginSignup from "./components/LoginSignup/LoginSignup";

function App() {
  const [progress, setProgress] = useState(0);
  const [themeMode, setThemeMode] = useState("light");
  useEffect(() => {
    // alert(themeMode);
  }, [themeMode]);
  const theme = createTheme({
    typography: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      color: "pink",
      fontWeightMedium: 500,
    },
    palette: {
      mode: themeMode,
      // primary: {
      //   main: mode == "dark" ? "#0ff0ff" : "#ff0000",
      // },
      // secondary: {
      //   main: "#0000ff",
      // },
      // otherColor: {
      //   main: "#0000ff",
      // },
      // colorOne: {
      //   main: "#6C4AB6",
      // },
      // colorTwo: {
      //   main: "#8D72E1",
      // },
      // colorThree: {
      //   main: "#8D9EFF",
      // },
      // colorFour: {
      //   main: "#B9E0FF",
      // },
      colorThree: {
        main: "#043e7d",
      },
      colorFour: {
        main: "#FFF7E9",
      },
      colorOne: {
        main: "#5791b3",
      },
      colorTwo: {
        main: themeMode == "light" ? "#256D85" : "#256D85",
      },
      colorFive: {
        main: "whitesmoke",
      },
      colorWhite: {
        main: themeMode == "light" ? "white" : "black",
      },
      colorWhiteSmoke: {
        main: themeMode == "light" ? "whitesmoke" : "#37474f66",
      },
      fontPrimaryColor: {
        // main: "#262626",
        // main: "#fff",
        main: themeMode == "light" ? "#262626" : "#f5f5f5",
      },
      fontSecondaryColor: {
        // main: "#8c8c8c",
        // main: "#f6f6f6",
        main: themeMode == "light" ? "#8c8c8c" : "#f6f6f6",
      },
      hoverColor: {
        main: "#CA5b33",
      },
    },
  });

  return (
    <div className={`my_app_router ${themeMode}`}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <LoadingBar height={3} color="#f11946" progress={progress} />
          {/* <Navbar /> */}
          <Routes>
            <Route exact path="/" element={<LoginSignup />} />
            <Route
              exact
              path="/home"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/answers/:questionId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/ask-question"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/my-questions"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/edit-question/:questionId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/all-answers/:questionId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/settings"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/profile"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/hostels"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/hostel-details/:hostelId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/upload-hostel-data"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/edit-hostel/:hostelId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/my-hostels"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/projects"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/project-details/:projectId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/post-project"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/edit-project/:projectId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/my-projects"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/scholarships"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/scholarship-details/:scholarshipId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/my-scholarships"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />

            <Route
              path="/edit-scholarship/:scholarshipId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/post-scholarship"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/internships"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/internship-details/:internshipId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              exact
              path="/post-internship"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/my-internships"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />

            <Route
              path="/edit-internship/:internshipId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/fyp"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/add-new-fyp"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/add-already-created-fyp"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/see-already-created-fyp"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/completed-fyp-detail/:fypId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/list-new-fyp-ideas"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/fyp/deletenewfyp"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/fyp/deletealreadyfyp"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/admin-dashboard"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/search"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            <Route
              path="/user-profile/:userId"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />

            <Route
              path="/edit-about"
              element={
                <CompleteProfile
                  setThemeMode={setThemeMode}
                  themeMode={themeMode}
                  isEdit={true}
                />
              }
            />
            <Route path="/complete-profile" element={<CompleteProfile />} />
            <Route path="/login" element={<LoginSignup />} />
            <Route path="/signup" element={<LoginSignup />} />

            <Route
              path="/email-verification/:userId/:uniqueString"
              exact
              element={<VerifyEmail />}
            />
            <Route
              path="/verify-your-account"
              exact
              element={<VerifyEmail />}
            />
            <Route
              path="/recover-password/:userId/:uniqueString"
              exact
              element={<RecoverPassword />}
            />
            <Route path="/forgot-password" exact element={<ForgotPassword />} />
            <Route
              path="*"
              element={
                <NewsFeed setThemeMode={setThemeMode} themeMode={themeMode} />
              }
            />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
